export default "<h1>Rules 规则</h1>\n<p>颜色主题定义的使用规则说明.</p>\n"